import React from 'react';

import {ArchiveTableRowProps, getRowClassName} from 'archive/components/modals/ArchiveTableRowConstants';
import getTestProps from 'test/lib/cypress/getTestProps';

export default function ArchiveTableRowName({
  itemForArchive,
  options,
  dataTestAttrs,
}: ArchiveTableRowProps): JSX.Element {
  return (
    <div className={getRowClassName(itemForArchive, options)} {...getTestProps(dataTestAttrs)}>
      {itemForArchive.name}
    </div>
  );
}
